import React from "react";
import styles from "./OfferSourceCell.module.css";
import {OfferInListDTO, OfferSource} from "../../../../../../../api/generated";

interface OfferSourceCellProps {
    offer: OfferInListDTO
}

export const OfferSourceCell: React.FC<OfferSourceCellProps> = ({offer}) => {

    return <div className={styles.wrapper}>
        <span className={styles.sourceType}>{offer.offerSource}</span>
        {offer.offerSource !== OfferSource.Manual && <span className={styles.sourceName}>{offer.offerSourceName}</span>}
    </div>
}
